// src/pages/visitor/SimpleFormsPage.jsx

import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../api/axios';
import styles from '../../App.module.css';
import { NotificationContainer } from 'react-notifications';
import { FaPencilAlt, FaSave, FaTimes } from 'react-icons/fa';
import notifications from '../../components/notifications';
import { FaRegCheckCircle, FaFileSignature, FaHourglassHalf } from 'react-icons/fa';
import { isAuthenticated } from '../../index';
import { PacmanLoader } from 'react-spinners';
import ReactCountryFlag from "react-country-flag";
import AgendamentoClienteAnalise from '../../pages/AgendamentoClienteAnalise';
import ShowAgendamento from './showAgendamento';



// IMPORTS EXTRAS PARA RECURSOS DE ADMIN
import ChatGPT from "../../components/ChatGPT";
import ClienteData from "../../components/Clientes/ClienteData"; // Se quiser exibir dados do cliente



// Mapeia cada tipo ao país correspondente
const countryByTipo = (tipo = "") => {
    switch (tipo.toLowerCase()) {
        case "adulto":
        case "kid":
        case "i140":
            return "US";        // EUA
        case "canada":
            return "CA";        // Canadá
        case "passport":
            return "BR";        // Brasil
        case "australia":
            return "AU";        // Austrália
        default:
            return null;        // sem bandeira
    }
};


// Componente que exibe a bandeira + texto
const TipoWithFlag = ({ tipo }) => {
    const code = countryByTipo(tipo);
    const label = (tipo || "").toUpperCase();

    return (
        <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
            {code && (
                <ReactCountryFlag
                    countryCode={code}
                    svg
                    style={{ width: 24, height: 18, display: "inline-block" }}
                    aria-label={code}
                />
            )}
            <strong>{label}</strong>
        </span>
    );
};


const ClienteFormsPage = () => {
    const { clienteId } = useParams();
    const [formularios, setFormularios] = useState([]);
    const [showVideo, setShowVideo] = useState(false);
    const [showVideoUrl, setShowVideoUrl] = useState('');
    const [showThumbnail, setShowThumbnail] = useState(true);
    const [thumb, setThumb] = useState('');
    const [loading, setLoading] = useState(true);
    const { userPermission } = isAuthenticated();

    // Funções originais
    const [editingFormId, setEditingFormId] = useState(null);
    const [tempLogin, setTempLogin] = useState('');
    const [tempDs160Id, setTempDs160Id] = useState('');
    const [login, setLogin] = useState(null);

    const isAdmin = typeof userPermission !== "undefined" && userPermission !== 0 && userPermission !== null;

    const alterarStatusFormulario = async (formularioId, novoStatus) => {
        try {
            const response = await api.post('/formularios/updateStatus', {
                formularioId,
                status: novoStatus
            });
            if (response.data.status) {
                setFormularios(prev =>
                    prev.map(f => f.id === formularioId ? { ...f, status: novoStatus } : f)
                );
                setNotificationType(8);
            } else {
                alert("Erro ao atualizar o status do formulário.");
            }
        } catch (error) {
            console.error("Erro ao atualizar status:", error);
            alert("Erro ao atualizar status.");
        }
    };




    const salvarDs160Id = async (formularioId, novoDs160Id) => {
        try {
            const response = await api.post('/formularios/updateDs160', {
                formularioId,
                ds160_id: novoDs160Id,
            });
            if (response.data.status) {
                setNotificationType(8); // Exibe notificação de sucesso
                return true;
            } else {
                alert(response.data.message || "Erro ao salvar o ID DS-160. Verifique se esse ID já não está sendo usado1.");
                return false;
            }
        } catch (error) {
            console.error("Erro ao salvar o ID DS-160:", error);
            alert("Erro ao salvar o ID DS-160. Verifique se esse ID já não está sendo usado2.");
            return false;
        }
    };

    const salvarLogin = async (clienteId, novoLogin) => {
        try {
            const response = await api.post('/produzir/updateLoginByClienteId', {
                clienteId,
                login: novoLogin,
            });
            if (response.data.status) {
                setNotificationType(8); // Exibe notificação de sucesso
                return true;
            } else {
                alert(response.data.message || "Erro ao atualizar o login.");
                return false;
            }
        } catch (error) {
            console.error("Erro ao salvar o login:", error);
            alert("Erro ao salvar o login.");
            return false;
        }
    };

    const STEPS_ADULTO = [
        'Dados Pessoais',
        'Informações de Viagem',
        'Informações de Contatos nos EUA',
        'Endereço e Contato',
        'Dados de Passaporte',
        'Informações de Família',
        'Ocupação Atual',
        'Formações Acadêmicas',
        'Informações Adicionais'
    ];
    const STEPS_KID = [
        'Dados Pessoais',
        'Informações de Viagem',
        'Residência e Vistos nos EUA',
        'Endereço e Contato',
        'Dados de Passaporte',
        'Informações de Família'
    ];
    const STEPS_PASSPORT = [
        'Dados Pessoais',
        'Endereço e Contato',
        'Dados do Passaporte',
    ];
    const STEPS_CANADA = [
        'Dados Pessoais',
        'Endereço e Contato',
        'Dados de Passaporte',
        'Informações de Família',
        'Informacoes De Viagem',
        'Vistos E Permanências',
        'Ocupação Atual',
        'Ocupação Anterior',
        'Documentos Adicionais',
        'Informações adcionais'

    ];
    const STEPS_AUSTRALIA = [
        'Dados Pessoais',
        'Endereço e Contato',
        'Dados do Passaporte',
        'Informações Adicionais'
    ];
    const STEPS_I140 = [
        'Dados Pessoais',
        'Endereço e Contato',
        'Dados do Passaporte',
        'Informações Adicionais'
    ];




    const getStepsByType = (tipo) => {
        if (tipo === 'kid') return STEPS_KID;
        if (tipo === 'passport') return STEPS_PASSPORT;
        if (tipo === 'canada') return STEPS_CANADA;
        if (tipo === 'australia') return STEPS_AUSTRALIA;
        if (tipo === 'i140') return STEPS_I140;
        return STEPS_ADULTO;
    };

    // Estado para armazenar a escolha do consulado
    const [consulado, setConsulado] = useState();
    const [consuladoInicial, setConsuladoInicial] = useState(null);
    const [notificationType, setNotificationType] = useState(0);

    /* Notificações Customizadas */
    useEffect(() => {
        if (notificationType && notifications[notificationType]) {
            notifications[notificationType]();
            setNotificationType(0); // Reseta o tipo de notificação após ser exibida
        }
    }, [notificationType]);

    const salvarConsulado = async () => {
        try {
            const response = await api.post('/cliente/consulado', {
                clienteId,
                consulado,
            });
            if (response.data.status) {
                setConsuladoInicial(consulado); // Atualiza o consulado inicial
                setNotificationType(8); // Exibe notificação de sucesso
            } else {
                setNotificationType(9); // Exibe notificação de erro
            }
        } catch (error) {
            console.error('Erro ao salvar consulado:', error);
            setNotificationType(9); // Exibe notificação de erro
        }
    };


    useEffect(() => {
        const fetchFormularios = async () => {
            try {
                const response = await api.get(`/formulariosCliente/${clienteId}`);
                if (response.data.status) {
                    const parsedFormularios = response.data.formularios.map(form => ({
                        ...form,
                        formularioData: JSON.parse(form.formularioData || '{}'),
                    }));
                    // console.log("Formulários do cliente:", parsedFormularios);
                    setFormularios(parsedFormularios);
                    setConsulado(response.data.consulado);
                    setConsuladoInicial(response.data.consulado); // Define o consulado inicial
                    // Inicializa login como único valor
                    const login = response.data.logins?.[0] || "E-mail não informado";
                    setLogin(login);
                    // console.log("data", response);
                }
            } catch (error) {
                console.error('Erro ao buscar formulários do cliente:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchFormularios();
    }, [clienteId]);

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '60vh'
            }}>
                <PacmanLoader color="#162768" size={50} />
            </div>
        );
    }

    const getStatusIcon = (status) => {
        switch (status) {
            case 'pendente':
                return <FaHourglassHalf size={24} color="gray" />;
            case 'preenchendo':
                return <FaFileSignature size={24} color="green" />;
            case 'completo':
                return <FaRegCheckCircle size={24} color="green" />;
            default:
                return null;
        }
    };

    // Função para acessar campos aninhados no estado
    const getNestedField = (data, fieldPath) => {
        const fields = fieldPath.split('.');
        return fields.reduce((acc, field) => {
            if (acc === null || acc === undefined) return null;
            return acc[field] !== undefined ? acc[field] : null;
        }, data);
    };

    const calculateProgress = (formData, tipo) => {
        const requiredFields = tipo === "passport"
            ? {
                0: ['nome', 'cpf', 'dataNascimento'],
                1: ['endereco', 'email', 'telefone', 'cep'],
                2: ['jaTevePassaporte', 'formaPagamento', 'postoPF']
            }
            : {
                0: ['nome', 'sobrenome', 'cidadeNascimento', 'dataNascimento', 'cpf'],
                1: ['dataChegada', 'duracaoViagem', 'cidadePretendida', 'hospedagem'],
                2: ['possuiSocialSecurity', 'possuiIdFiscalEUA', 'esteveEUA'],
                3: ['endereco', 'bairro', 'cep', 'cidadeEstado'],
                4: ['dataEmissaoPassaporte', 'dataExpiracaoPassaporte', 'numeroPassaporte'],
                5: ['nomePai', 'dataNascimentoPai', 'nomeMae', 'dataNascimentoMae'],
                6: ['ocupacaoAtual', 'empresa', 'rendaMensal'],
                7: ['ocupacaoAnterior', 'formacaoAcademica'],
                8: ['participaOrganizacoes', 'temHabilidadesEspeciais', 'temCondenacoes']
            };

        let totalFields = 0;
        let filledFields = 0;
        Object.values(requiredFields).forEach(fields => {
            totalFields += fields.length;
            fields.forEach(field => {
                const value = getNestedField(formData, field);
                if (Array.isArray(value)) {
                    if (value.length > 0) filledFields++;
                } else {
                    if (value && value.trim() !== '') filledFields++;
                }
            });
        });
        return Math.round((filledFields / totalFields) * 100);
    };




    const renderColoredSteps = (formData, tipo, formStatus) => {
        const requiredFields = {
            passport: {
                0: ['nome', 'cpf', 'dataNascimento'],
                1: ['endereco', 'email', 'telefone', 'cep'],
                2: ['jaTevePassaporte', 'formaPagamento', 'postoPF'],
            },
            adulto: {
                0: ['nome', 'sobrenome', 'cidadeNascimento', 'dataNascimento', 'cpf'],
                1: ['dataChegada', 'duracaoViagem', 'cidadePretendida', 'hospedagem'],
                2: ['possuiSocialSecurity', 'possuiIdFiscalEUA', 'esteveEUA'],
                3: ['endereco', 'bairro', 'cep', 'cidadeEstado'],
                4: ['dataEmissaoPassaporte', 'dataExpiracaoPassaporte', 'numeroPassaporte'],
                5: ['nomePai', 'dataNascimentoPai', 'nomeMae', 'dataNascimentoMae'],
                6: ['ocupacaoAtual', 'empresa', 'rendaMensal'],
                7: ['ocupacaoAnterior', 'formacaoAcademica'],
                8: ['participaOrganizacoes', 'temHabilidadesEspeciais', 'temCondenacoes'],
            },
            kid: {
                0: ['nome', 'sobrenome', 'cidadeNascimento', 'dataNascimento', 'cpf'],
                1: ['dataChegada', 'duracaoViagem', 'cidadePretendida', 'hospedagem'],
                2: ['possuiSocialSecurity', 'possuiIdFiscalEUA', 'esteveEUA'],
                3: ['endereco', 'bairro', 'cep', 'cidadeEstado'],
                4: ['dataEmissaoPassaporte', 'dataExpiracaoPassaporte', 'numeroPassaporte'],
                5: ['nomePai', 'dataNascimentoPai', 'nomeMae', 'dataNascimentoMae'],
                6: ['ocupacaoAtual', 'empresa', 'rendaMensal'],
                7: ['ocupacaoAnterior', 'formacaoAcademica'],
                8: ['participaOrganizacoes', 'temHabilidadesEspeciais', 'temCondenacoes'],
            },
            canada: {
                0: ['nome', 'sobrenome', 'cidadeNascimento', 'dataNascimento', 'cpf'],
                1: ['endereco', 'cep', 'cidadeEstado',],
                2: ['dataEmissaoPassaporte', 'dataExpiracaoPassaporte', 'numeroPassaporte', "cidadeEstadoEmissaoPassaporte", "numeroIdentidade", "dataEmissaoIdentidade", "cidadeEstadoEmissaoIdentidade"],
                3: [],
                4: ['motivoViagemCanada', 'tempoPermanenciaCanada', 'dataPretendidaViagem', 'cidadePretendidaCanada'],
                5: [],
                6: ['ocupacaoAtual', 'dataInicio',],
                7: [],
                8: [],
                9: []
            }
        };

        const activeSteps = getStepsByType(tipo); // ex: [0,1,2,3,4...]
        const fieldsByStep = requiredFields[tipo] || {};

        const getStepStatus = (stepIndex) => {
            const stepFields = fieldsByStep[stepIndex];
            if (!stepFields) return '#646464'; // passo indefinido = cinza

            const isComplete = stepFields.every((field) => {
                const value = getNestedField(formData, field);
                return Array.isArray(value) ? value.length > 0 : value && value.toString().trim() !== '';
            });
            const isPartial = stepFields.some((field) => {
                const value = getNestedField(formData, field);
                return Array.isArray(value) ? value.length > 0 : value && value.toString().trim() !== '';
            });

            return isComplete ? '#479c00' : isPartial ? 'rgb(251 141 20)' : '#646464';
        };

        if (formStatus === 'pendente') return null;

        let lastStepAnswered = 0;
        for (let i = 0; i < activeSteps.length; i++) {
            const stepFields = fieldsByStep[i];
            if (!stepFields) continue;

            const answered = stepFields.some((field) => {
                const value = getNestedField(formData, field);
                return Array.isArray(value) ? value.length > 0 : value && value.toString().trim() !== '';
            });

            if (answered) {
                lastStepAnswered = i + 1;
            }
        }
        if (lastStepAnswered === 0) lastStepAnswered = 1;
        const stepsToShow = activeSteps.slice(0, lastStepAnswered);

        return (
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                {stepsToShow.map((_, index) => (
                    <div
                        key={index}
                        style={{
                            width: '50px',
                            height: '50px',
                            backgroundColor: getStepStatus(index),
                            borderRadius: '5px',
                            textAlign: 'center',
                            color: 'white',
                            lineHeight: '50px',
                        }}
                    >
                        {index + 1}
                    </div>
                ))}
            </div>
        );
    };






    // RENDERIZAÇÃO DOS FORMULÁRIOS
    const renderizarFormulario = (form) => {
        const tipo = form.tipo;
        const nomePreenchido = form.formularioData?.nome && form.formularioData?.sobrenome
            ? `${form.formularioData.nome} ${form.formularioData.sobrenome}`
            : null;

        const getAnoNascimento = (dataNascimento) => {
            if (!dataNascimento) return '';
            const [ano] = dataNascimento.split('-');
            return ano;
        };

        return (
            <div
                key={form.id}
                className={styles.formularioCard}
                style={{
                    width: "calc(100% - 20px)",
                    margin: "10px",
                    backgroundColor: "#bbbbbb",
                    borderRadius: "10px",
                    textAlign: "center",
                    position: "relative", // <--- ESSENCIAL PARA FUNCIONAR O OVERLAY
                    zIndex: 0
                }}
            >
                <div style={{ padding: "10px" }}>
                    {nomePreenchido && (
                        <div style={{ padding: "10px", marginBottom: '10px', fontWeight: 'bold', color: 'green' }}>
                            {nomePreenchido}
                            {form.formularioData.dataNascimento && (
                                <>, {getAnoNascimento(form.formularioData.dataNascimento)}</>
                            )}
                        </div>
                    )}
                    <div
                        style={{
                            marginBottom: "10px",
                            fontWeight: "bold",
                            display: "flex",
                            justifyContent: "space-around",
                            alignItems: "center",
                            position: "relative",
                            textAlign: "center"
                        }}
                    >
                        {isAdmin ? (
                            <>
                                <span>
                                    {editingFormId === form.id ? (
                                        <input
                                            type="text"
                                            value={tempDs160Id}
                                            onChange={(e) => setTempDs160Id(e.target.value)}
                                            style={{
                                                padding: "5px",
                                                border: "1px solid #ccc",
                                                borderRadius: "5px",
                                                width: "80%",
                                            }}
                                        />
                                    ) : (
                                        form.ds160_id || "Número"
                                    )}
                                </span>
                                {editingFormId === form.id ? (
                                    <div style={{ display: "flex", gap: "10px" }}>
                                        <button
                                            onClick={async () => {
                                                const sucesso = await salvarDs160Id(form.id, tempDs160Id);
                                                if (sucesso) {
                                                    setFormularios((prev) =>
                                                        prev.map((f) =>
                                                            f.id === form.id ? { ...f, ds160_id: tempDs160Id } : f
                                                        )
                                                    );
                                                    setEditingFormId(null);
                                                }
                                            }}
                                            style={{
                                                padding: "5px 10px",
                                                backgroundColor: "#4CAF50",
                                                color: "#fff",
                                                borderRadius: "5px",
                                            }}
                                        >
                                            <FaSave /> Salvar
                                        </button>
                                        <button
                                            onClick={() => {
                                                setEditingFormId(null);
                                                setTempDs160Id(form.ds160_id);
                                            }}
                                            style={{
                                                padding: "5px 10px",
                                                backgroundColor: "#f44336",
                                                color: "#fff",
                                                borderRadius: "5px",
                                            }}
                                        >
                                            <FaTimes /> Cancelar
                                        </button>
                                    </div>
                                ) : (
                                    <button
                                        onClick={() => {
                                            setEditingFormId(form.id);
                                            setTempDs160Id(form.ds160_id || "");
                                        }}
                                        style={{
                                            padding: "5px 10px",
                                            backgroundColor: "green",
                                            color: 'var(--corPrimaria)',
                                            borderRadius: "5px",
                                            position: "absolute",
                                            border: "none",
                                            right: "0",
                                            fontWeight: "bold",
                                            color: "white",
                                        }}
                                    >
                                        <FaPencilAlt /> Editar
                                    </button>
                                )}
                            </>
                        ) : (
                            <span>{form.ds160_id || "Número"}</span>
                        )}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        <div><TipoWithFlag tipo={tipo} /> ({form.status})</div>

                        <div>{getStatusIcon(form.status)}</div>
                    </div>
                    <div>
                        {renderColoredSteps(form.formularioData || {}, tipo, form.status)}
                        {form.status !== 'pendente' && (
                            <div style={{ marginTop: '10px', textAlign: 'center' }}>
                                {(() => {
                                    const progress = calculateProgress(form.formularioData || {}, tipo);
                                    return (
                                        <>
                                            <div style={{ background: '#eee', borderRadius: '10px', width: '100%', height: '20px' }}>
                                                <div style={{
                                                    width: `${progress}%`,
                                                    background: '#479C00',
                                                    height: '100%',
                                                    borderRadius: '10px',
                                                    transition: 'width 0.3s'
                                                }}></div>
                                            </div>
                                            {/* <p>{progress}% preenchido</p> */}
                                        </>
                                    );
                                })()}
                            </div>
                        )}
                    </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>

                    <div
                        style={{
                            width: "100%",
                            maxWidth: "300px",
                            display: isAdmin ? "flex" : "block",
                            justifyContent: isAdmin ? "space-between" : undefined,
                            alignItems: isAdmin ? "center" : undefined,
                            padding: 0,
                            gap: isAdmin ? "5px" : undefined,
                        }}
                    >
                        {(form.status !== 'completo' || isAdmin) && (
                            <a
                                style={{ margin: "10px", display: "flex", width: "60%", maxWidth: "300px" }}
                                key={form.id}
                                href={`/preencher/${form.id}`}
                            >
                                <p
                                    style={{
                                        backgroundColor: "var(--corPrimaria)",
                                        borderRadius: "10px",
                                        color: "white",
                                        fontWeight: "800",
                                        fontSize: "1rem",
                                        padding: "10px",
                                        margin: 0,
                                        flex: 1,
                                        textAlign: "center",
                                        zIndex: 10,
                                    }}
                                >
                                    PREENCHER
                                </p>
                            </a>
                        )}

                        {isAdmin && (
                            <>
                                <a
                                    style={{ margin: "10px", display: "flex", width: "60%", maxWidth: "300px" }}
                                    key={form.id}
                                >
                                    <p
                                        style={{
                                            backgroundColor: "red",
                                            borderRadius: "10px",
                                            color: "white",
                                            fontWeight: "800",
                                            fontSize: "1rem",
                                            padding: "10px",
                                            margin: 0,
                                            flex: 1,
                                            textAlign: "center",
                                            cursor: "pointer",
                                            position: "relative",
                                            zIndex: 10,
                                        }}
                                        onClick={() =>
                                            form.status === "completo"
                                                ? alterarStatusFormulario(form.id, "preenchendo")
                                                : alterarStatusFormulario(form.id, "completo")
                                        }
                                    >
                                        {form.status === "completo" ? "RE-EDITAR" : "FINALIZAR"}
                                    </p>
                                </a>
                            </>
                        )}
                    </div>
                </div>
                {form.status === 'completo' && (
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.6)",
                            color: "white",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "10px",
                            zIndex: 5,
                            pointerEvents: "none" // permite clicar nos botões acima
                        }}
                    >
                        <h2 style={{ fontSize: "1.5rem", fontWeight: "bold" }}>FINALIZADO</h2>
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className={styles.app}>
            <NotificationContainer />
            {/* Exibe ClienteData e Vídeo para Admin */}
            {isAdmin && (
                <ClienteData clienteID={clienteId} />
            )}

            <ShowAgendamento clienteID={clienteId} />

            {/* Seção consulado (padrão) */}
            <div className={styles.cadastroItems06} style={{ paddingBlock: "20px", borderRadius: "20px", backgroundColor: "white", marginBlock: "10px", maxWidth: "600px", textAlign: "center" }}>
                <div style={{ width: "100%" }}>
                    <h2>Consulado/Embaixada</h2>




                </div>
                <p>Escolha o mais próximo de você, ou o consulado da sua preferência.</p>
                <div>
                    <div className={styles.selectConsuladoContainer} style={{ marginTop: "10px", padding: "10px" }}>
                        {[
                            { value: 54, label: "Brasília" },
                            { value: 55, label: "Rio de Janeiro" },
                            { value: 56, label: "São Paulo" },
                            { value: 57, label: "Recife" },
                            { value: 124, label: "Porto Alegre" }
                        ].map(({ value, label }) => (
                            <div
                                key={value}
                                className={`${styles.selectConsulado} ${consulado === value ? styles.active : ""}`}
                                onClick={() => setConsulado(value)}
                            >
                                {label}
                            </div>
                        ))}
                    </div>
                    {consulado !== consuladoInicial && (
                        <button
                            onClick={salvarConsulado}
                            style={{ marginTop: "20px", padding: "10px", color: "white", fontSize: "1rem", backgroundColor: "var(--corPrimaria)", borderRadius: "10px" }}
                            className={styles.confirmButton}
                        >
                            Confirmar Consulado
                        </button>
                    )}
                </div>
            </div>
            



            {/* {isAdmin ? <AgendamentoClienteAnalise /> : <></>} */}


            {/* Login grupo para admin */}
            {formularios.length > 0 && (
                <div className={styles.cadastroItems06} style={{ paddingBlock: "20px", borderRadius: "20px", backgroundColor: "white", marginBlock: "10px", maxWidth: "600px", textAlign: "center" }}>
                    <div style={{ width: "100%" }}>
                        <h2>{isAdmin ? "Email da conta" : "Preencha On-Line"}</h2>
                    </div>
                    {isAdmin && (
                        <div style={{ marginBottom: "10px", fontWeight: "bold", display: "flex", alignItems: "center", gap: "10px" }}>
                            {editingFormId === "group" ? (
                                <input
                                    type="text"
                                    value={tempLogin}
                                    onChange={(e) => setTempLogin(e.target.value)}
                                    style={{
                                        padding: "5px",
                                        border: "1px solid #ccc",
                                        borderRadius: "5px",
                                        width: "70%",
                                    }}
                                />
                            ) : (
                                <span>{login?.trim() ? login : "E-mail não informado"}</span>

                            )}
                            {editingFormId === "group" ? (
                                <>
                                    <button
                                        onClick={async () => {
                                            const sucesso = await salvarLogin(clienteId, tempLogin);
                                            if (sucesso) {
                                                setLogin(tempLogin);
                                                setEditingFormId(null);
                                            }
                                        }}
                                        style={{
                                            padding: "5px 10px",
                                            backgroundColor: "#4CAF50",
                                            color: "#fff",
                                            borderRadius: "5px",
                                        }}
                                    >
                                        <FaSave /> Salvar
                                    </button>
                                    <button
                                        onClick={() => {
                                            setEditingFormId(null);
                                            setTempLogin(login);
                                        }}
                                        style={{
                                            padding: "5px 10px",
                                            backgroundColor: "#f44336",
                                            color: "#fff",
                                            borderRadius: "5px",
                                        }}
                                    >
                                        <FaTimes /> Cancelar
                                    </button>
                                </>
                            ) : (
                                <button
                                    onClick={() => {
                                        setEditingFormId("group");
                                        setTempLogin(login === "E-mail não informado" ? "" : login);
                                    }}

                                    style={{
                                        padding: "5px 10px",
                                        backgroundColor: "green",
                                        color: 'white',
                                        borderRadius: "5px",
                                        border: "none",
                                        fontWeight: "bold",
                                        color: "white",


                                    }}
                                >
                                    <FaPencilAlt /> Editar
                                </button>
                            )}
                        </div>
                    )}
                    <div style={{ width: "100%", display: "flex", flexWrap: "wrap" }}>
                        {formularios.map(form => renderizarFormulario(form))}
                    </div>
                </div>
            )}
            {isAdmin && (
                <div className={styles.cadastroItems06} style={{ marginBlock: "10px", paddingBlock: "20px", borderRadius: "20px", backgroundColor: "white", maxWidth: "600px" }}>
                    <ChatGPT contextMessage={{ role: "system", content: JSON.stringify(formularios) }} />
                </div>
            )}
            {formularios.length === 0 && <p>Nenhum formulário pendente para preenchimento.</p>}
        </div>
    );
};
export default ClienteFormsPage;
